<template lang="pug">
    .analog-clock-wrapper
        figure.analog-clock
            .shift.am(v-if="minute < 12 * 60")
            .shift.mid(v-if="minute >= 12 * 60")
            .shift.late(v-if="minute >= 12 * 60")
                //- .text 1
            figcaption.analog-clock__face
                span.analog-clock__notch(v-for="n in 60"
                    :key="n"
                    :class="{ '-long': !(n % 5) }"
                    :style="{ transform: `rotate(${n * 6}deg)` }")
            
            //- span(class="analog-clock__hand -seconds" :style="seconds")
            //- span(class="analog-clock__hand -minutes" :style="minutes")
            span(class="analog-clock__hand -hours" :style="hours")
        .digital-clock {{ convert(minute) }}
</template>

<script>
export default {
  props: { currentMinute: {type: Number, default: 0 } },
  data() {
    return {
      rotation: { hours: 0, minutes: 0, seconds: 0 },
      minute: 0
    };
  },
  computed: {
    hours() {
      return {
        transform: `translate3d(-50%, 0, 0) rotate(${this.rotation.hours}deg)`
      };
    },
    minutes() {
      return {
        transform: `translate3d(-50%, 0, 0) rotate(${this.rotation.minutes}deg)`
      };
    },
    seconds() {
      return {
        transform: `translate3d(-50%, 0, 0) rotate(${this.rotation.seconds}deg)`
      };
    }
  },
  watch: {
    // tick() {
    //     this.rotation.seconds += 6
    //     this.rotation.minutes += 0.1
    // },
    // minute(to, from) {
    //     if (from === to) return;
    //     this.rotation.hours += 0.5
    // },
    currentMinute(m) {
      this.minute = m;
      let currentHour = (this.hour = Math.floor(m / 60));
      let currentMinute = Math.floor(m % 60);
      this.rotation.hours = currentHour * 30 + currentMinute * 0.5;
    }
  },
  mounted() {
    let date = new Date();
    let [h, m, s] = [date.getHours(), date.getMinutes(), date.getSeconds()];
    h = 6;
    m = 0;
    s = 0;
    // this.minute = h * 60 + m;
    this.minute = 400;
    this.rotation = {
      hours: h * 30 + m * 0.5,
      minutes: m * 6 + s * 0.1,
      seconds: s * 6
    };
  },
  methods: {
    convert: n =>
      `0${(n / 60) % 12 ^ 0}`.slice(-2).replace(/^00/, "12") +
      ":" +
      ("0" + (n % 60)).slice(-2) +
      " " +
      (n < 12 * 60 ? "AM" : "PM")
  }
};
</script>

<style lang="scss" scoped>
.analog-clock-wrapper {
  position: relative;
}
.analog-clock {
  margin: 0;
  overflow: hidden;
  top: 70px;
  width: 20vw;
  max-width: 360px;
  max-height: 360px;
  height: 20vw;
  left: 0px;
  position: absolute;
  border-radius: 100%;
  background-color: white;
  // transform: translate3d(-1.5rem, 0, 0);
  filter: drop-shadow(0 0.125rem 0.5rem rgba(black, 0.1));

  .am {
    background-color: rgba(253, 128, 93, 0.7);
    top: 0;
    left: 0;
  }
  .mid {
    background-color: rgba(51, 153, 51, 0.7);
    right: 0;
    top: -50%;
    transform-origin: 0% 100%;
    transform: rotate(0deg) skewY(60deg);
  }
  .shift.late {
    background-color: rgba(0, 153, 255, 0.7);
    left: -25%;
    top: -25%;
    width: 100%;
    transform-origin: 0% 133%;
    transform: rotate(15deg) skewY(45deg);
  }
  .shift {
    overflow: hidden;
    position: absolute;
    width: 50%;
    height: 100%;

    // right: 0;
    // width: 50%;
    // height: 50%;
    // transform-origin: 0% 100%;
    // transform: rotate(0deg) skewY(30deg);
    .text {
      position: absolute;
      left: -100%;
      width: 200%;
      height: 200%;
      text-align: center;
      transform: skewY(-60deg) rotate(15deg);
      padding-top: 20px;
      background-color: green;
    }
  }

  &::after {
    top: 50%;
    left: 50%;
    content: "";
    width: 2.5%;
    height: 2.5%;
    position: absolute;
    border-radius: 100%;
    background-color: #edbec5;
    transform: translate3d(-50%, -50%, 0);
  }

  &__face {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__notch {
    transform-origin: 50% 100%;
    position: absolute;
    width: 1px;
    height: 49%;
    bottom: 50%;
    left: 50%;

    &::after {
      content: "";
      width: 100%;
      height: 2.5%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #3e4346;
    }

    &.-long::after {
      width: 2px;
      height: 7.5%;
    }
  }

  &__hand {
    transform-origin: 50% 100%;
    background-color: #1e2427;
    position: absolute;
    width: 2px;
    height: 40%;
    bottom: 50%;
    left: 50%;
    border-radius: 2px;
    transition: transform 0.3s linear;

    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      height: 10%;
      background-color: inherit;
      backface-visibility: hidden;
    }

    &.-hours {
      height: calc(100% / 3);
      width: 3px;
      border-radius: 3px;
      //   transition: transform 60s linear;
    }

    &.-seconds {
      width: 1px;
      height: 45%;
      border-radius: 0;
      background-color: #edbec5;
      transition: transform 100ms cubic-bezier(0.6, 0.05, 0, 1.6);

      &::after {
        height: 12.5%;
      }
    }
  }
}
h3 {
  font-size: 36px;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  text-align: center;
}
.digital-clock {
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  font-size: 36px;
  text-align: center;
}
</style>
